import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Divider, Space, Typography } from 'antd';
const { Text } = Typography;
const SelectOptions = ({ data, title, value, setValue }) => {
    const checkAll = (data === null || data === void 0 ? void 0 : data.length) === value.length;
    const indeterminate = value.length > 0 && value.length < (data ? data === null || data === void 0 ? void 0 : data.length : 0);
    const handleChange = (newCheckedList) => {
        setValue(newCheckedList);
    };
    const onCheckAllChange = (e) => {
        const values = data ? data === null || data === void 0 ? void 0 : data.map((option) => option === null || option === void 0 ? void 0 : option.value) : [];
        setValue(e.target.checked ? values : []);
    };
    return (_jsxs(Space, { direction: "vertical", size: 'small', children: [_jsx(Text, { strong: true, children: title }, `${title}_title`), _jsx(Checkbox, { indeterminate: indeterminate, onChange: onCheckAllChange, checked: checkAll, children: "All" }, `${title}_all_check`), _jsx(Checkbox.Group, { options: data, value: value, onChange: handleChange, style: { display: 'grid' } }, `${title}_Group_check`), _jsx(Divider, {}, `${title}_filter_panel_divider1`)] }, `${title}_space`));
};
export default SelectOptions;
